module.exports = __webpack_public_path__ + "static/img/logo-agrospectrum.0b691a5c.png";